if (parent.frames.length) {
	var addListenerMethod = window.addEventListener ? "addEventListener" : "attachEvent";
	var messageEvent = addListenerMethod == "attachEvent" ? "onmessage" : "message";

	var modalOffset = $(".modal").offset().top;
	var thisSiteHeight = $("body").height() + 0;

	var eventOrigin, eventSource, targetId, resizeTimeout;

	var cookieSet = false;

	window[addListenerMethod](
		messageEvent,
		function (event) {
			eventOrigin = event.origin;
			eventSource = event.source;

			if (!event.data || !event.data.length) {
				return;
			}

			var eventData = event.data.match(/^height-(\d+)$/);
			if (eventData != null) {
				targetId = parseInt(eventData[1], 10);

                eventSource.postMessage(targetId + "-" + thisSiteHeight + "-" + 0, eventOrigin);
			} else {
				try {
					eventData = JSON.parse(event.data);
					var windowHeight = eventData.params.winHeight;
					var newScrollY = eventData.params.scrollY;
					var offsetY = eventData.params.offsetY;
					var difference = newScrollY - (offsetY + modalOffset);
					// var downloadBardifference = newScrollY - offsetY;

					// $("#downloadbar").css("top", windowHeight - 60);

					// var max = document.body.clientHeight - windowHeight + 60;
					// if (newScrollY < max) {
					// 	$("#downloadbar").css("transform", "translateY(" + downloadBardifference + "px)");
					// } else {
					// 	$("#downloadbar").css("transform", "translateY(" + max + "px)");
					// }

					if (difference >= 0) {
						$(".modal").css("transform", "translateY(" + difference + "px)");
						$(".modal").css("height", windowHeight);
					} else {
						$(".modal").css("transform", "");
					}

					if (eventData.type === "consent" && eventData.params && typeof eventData.params.cookieValue === "string") {
						var cookies = eventData.params.cookieValue.split(",");
                        // console.log(eventData.params.cookieValue);

						cookieSet = cookies.length > 0;

						if (cookies.includes("2")) {
							activateTracking();
						}
					}
				} catch (error) {
					console.error("Event data invalid", error);
				}
			}
		},
		false
	);

	var messageInterval, intervalTimeout;

	function moveStickyNav() {
		clearInterval(messageInterval);
		clearTimeout(intervalTimeout);

		messageInterval = setInterval(function () {
			window.parent.postMessage(
				{
					type: "getDimensions",
				},
				"*"
			);
		}, 5);

		intervalTimeout = setTimeout(function () {
			clearInterval(messageInterval);
		}, 500);
	}

	function propagateResizeing(offsetPosition) {
		if (window.self != window.top) {
			var thisSiteHeight = $("body").height() + 60;

			if (offsetPosition !== undefined) {
				eventSource.postMessage(targetId + "-" + thisSiteHeight + "-" + offsetPosition, eventOrigin);
			} else {
				eventSource.postMessage(targetId + "-" + thisSiteHeight, eventOrigin);
			}
		}
	}

	function activateTracking() {
		//    <script id="_etLoader" type="text/javascript" charset="UTF-8" data-block-cookies="true" data-respect-dnt="true" data-secure-code="9J34VK" src="//code.etracker.com/code/e.js" async></script>
		// var etracker = document.createElement("script");
		// etracker.setAttribute("id", "_etLoader");
		// etracker.setAttribute("type", "text/javascript");
		// etracker.setAttribute("charset", "UTF-8");
		// etracker.setAttribute("async", true);
		// etracker.dataset.blockCookies = true;
		// etracker.dataset.respectDnt = true;
		// etracker.dataset.secureCode = "9J34VK";
		// etracker.onload = function () {
		// 	var buttons = document.querySelectorAll("#downloadbar, .btn--default");
		// 	buttons.forEach(function (button) {
		// 		var trackEvent = button.dataset.trackEvent;
		// 		button.setAttribute("onmousedown", "_etracker.sendEvent(new et_UserDefinedEvent('morgenkannkommen.html', 'Download', 'App', '" + trackEvent + "'));");
		// 	});
		// };
		// etracker.setAttribute("src", "//code.etracker.com/code/e.js");
		// document.body.append(etracker);
	}

	setInterval(function () {
		moveStickyNav();

		// if (!cookieSet) {
		// 	window.parent.postMessage(
		// 		{
		// 			type: "getConsent",
		// 		},
		// 		"*"
		// 	);
		// }

	}, 100);

	$(window).resize(function () {
		$(".modal").css("transform", "");
		modalOffset = $(".modal").offset().top;

		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			propagateResizeing();
		}, 100);
	});

	$(document).ready(function () {
		modalOffset = $(".modal").offset().top;
	});

	$(".anker-link").each(function () {
		$(this).click(function (event) {
			event.preventDefault();

			var target = $($(this).attr("href"));
			var targetOffset = target.offset().top;

			window.parent.postMessage(
				{
					type: "scroll",
					params: {
						scrollTo: targetOffset,
					},
				},
				"*"
			);
			moveStickyNav();
		});
	});

	$(".accordion__button").click(function () {
		setTimeout(function () {
			$(window).trigger("resize");
		}, 100);
	});

	$(".modal-close").click(function () {
		setTimeout(function () {
			window.parent.postMessage(
				{
					type: "scroll",
					params: {
						scrollTo: $(".slidercontainer").offset().top,
					},
				},
				"*"
			);
		}, 100);
	});

	$(".btn-modal-close").click(function () {
		setTimeout(function () {
			window.parent.postMessage(
				{
					type: "scroll",
					params: {
						scrollTo: $(".slidercontainer").offset().top,
					},
				},
				"*"
			);
		}, 100);
	});
}
